// @ts-check
import { decodeAppConfig } from '@ringba/config/codec';

/**
 * The runtime config `index.html` carries, so the bundles stay the same across releases.
 * @type {import('@ringba/config/v2').V2AppConfig}
 */
export const AppConfig = decodeAppConfig(window.__APP_CONFIG__);
